import{useContext}from'react';import{ReactReduxContext}from'../components/Context';import{useReduxContext as useDefaultReduxContext}from'./useReduxContext';/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */export function createStoreHook(){var context=arguments.length>0&&arguments[0]!==undefined?arguments[0]:ReactReduxContext;var useReduxContext=// @ts-ignore
context===ReactReduxContext?useDefaultReduxContext:function(){return useContext(context);};return function useStore(){var _useReduxContext=useReduxContext(),store=_useReduxContext.store;// @ts-ignore
return store;};}/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */export var useStore=/*#__PURE__*/createStoreHook();